// this is the wrapper that will fetch the survey and store it in state
import { Backdrop, CircularProgress } from "@mui/material";
import { FairPaySurveyResponseContext } from "contexts/FairPaySurveyResponse";
import { useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";

import { fetcher } from "utils/api";

import { FairPaySurveyResponse } from "../schemas";
import GenerateResults from "./GenerateResults";
import SurveyOnboardingForm from "./Onboarding";
import SurveyResults from "./SurveyResults";

export default function SurveyWrapper() {
  const { surveyUuid } = useParams();
  const { fairPaySurveyResponse, setFairPaySurveyResponse } = useContext(
    FairPaySurveyResponseContext,
  );
  const [loading, setLoading] = useState<boolean>(true);

  const fetchSurvey = async (): Promise<FairPaySurveyResponse | null> => {
    if (!surveyUuid) {
      return null;
    }

    setLoading(true);

    try {
      const { surveyResponse } = await fetcher(
        `/api/organization/fair-pay-survey-responses/${surveyUuid}`,
        "GET",
      );
      setFairPaySurveyResponse(surveyResponse);
      return surveyResponse;
    } catch {
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSurvey();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyUuid]);

  return loading ? (
    <Backdrop
      sx={{
        backgroundColor: "#fff",
        zIndex: 9999,
        position: "absolute",
      }}
      open={loading}
    >
      <CircularProgress />
    </Backdrop>
  ) : fairPaySurveyResponse ? (
    <Routes>
      <Route path="/generate" element={<GenerateResults />} />
      <Route path="/results" element={<SurveyResults />} />
      <Route path="/onboarding" element={<SurveyOnboardingForm />} />
    </Routes>
  ) : (
    <Navigate to="../" replace={true} />
  );
}
